import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <div >
             <nav className="bg-gray-300 pb-20 text-xl font-medium ">
                {/* <link to="/home"><img className="bg-white px-2 pt-3 ml-2" src={logo} alt="" /></link> */}
                <div className="mb-10  text-center pb-7 pt-5">
                    <Link className="mx-10 lg:inline block" to="/home">Home</Link>
                    <Link className="mx-10 lg:inline block" to="/projects">Projects</Link>
                    <Link className="mx-10 lg:inline block" to="/about">About Me</Link>
                    <Link className="mx-10 lg:inline block" to="/contact">Contact Me</Link>
                    <Link className="mx-10 lg:inline block" to="/blogs">Blogs</Link>
                    <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl"><i class="fas fa-download"> <a   href="https://drive.google.com/uc?export=download&id=1jdFnsTD_AQmd4SeB1McztAAa-oHzZjBI">Resume</a></i></button> 
                    
                        
                    

                </div>
            </nav>
        </div>
    );
};

export default Header;